export default "__VITE_ASSET__6a89b04b__"